import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AdminLayoutComponent } from './layout/admin-layout/admin-layout.component';
import { UsersComponent } from './components/users/users.component';
import { AuthGuard } from './core/gaurds/auth-guard';
import { EventsComponent } from './components/events/events.components';
import { SingleEventsComponent } from './components/singleEvent/single-event.component';
import { NewsComponent } from './components/news/news.component';
import { SingleNewsComponent } from './components/singleNews/single-news.component';
import { ResourcesComponent } from './components/resources-all/resources/resources.component';
import { MemberViewComponent } from './components/member-view/member-view.component';
import { MyProfileComponent } from './components/my-profile/my-profile.component';
import { MediaComponent } from './components/media/media.component';
import { DashbordComponent } from './components/dashbord/dashbord.component';
import { ResourceArticleComponent } from './components/resources-all/resource-article/resource-article.component';
import { ResourceVideoComponent } from './components/resources-all/resource-video/resource-video.component';
import { SingleAlbumComponent } from './components/single-album/single-album.component';
import { SingleResourceComponent } from './components/single-resource/single-resource.component';
import { ActsComponent } from './components/acts/acts.component';
import { JudgmentsOrdersComponent } from './components/judgments-orders/judgments-orders.component';
import { SearchJudgmentsComponent } from './components/search-judgments/search-judgments.component';
import { DownloadsComponent } from './components/downloads/downloads.component';

const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: '/auth/login' },
  // Handling User authentication
  {
    path: 'auth',
    loadChildren: () =>
      import('./modules/auth/auth.module').then((m) => m.AuthModule),
  },
  // App Components
  {
    path: 'admin',
    canActivate: [AuthGuard],
    component: AdminLayoutComponent,
    children: [
      {
        path: '',
        redirectTo: '/admin/users',
        pathMatch: 'full',
      },
      {
        path: 'users',
        component: UsersComponent,
      },
      {
        path: 'events',
        component: EventsComponent,
      },
      {
        path: 'single-event',
        component: SingleEventsComponent,
      },
      {
        path: 'news',
        component: NewsComponent,
      },
      {
        path: 'single-news',
        component: SingleNewsComponent,
      },
      {
        path: 'resources',
        component: ResourcesComponent,
      },
      {
        path: 'resources-video',
        component: ResourceVideoComponent,
      },
      {
        path: 'resources-article',
        component: ResourceArticleComponent,
      },
      {
        path: 'single-resource/:id',
        component: SingleResourceComponent,
      },
      {
        path: 'member-view',
        component: MemberViewComponent,
      },
      {
        path: 'media',
        component: MediaComponent,
      },
      {
        path: 'dashboard',
        component: DashbordComponent,
      },
      {
        path: 'my-profile',
        component: MyProfileComponent,
      },
      {
        path: 'single-album',
        component: SingleAlbumComponent,
      },
      {
        path: 'acts',
        component: ActsComponent,
      },
      {
        path: 'judgments-orders',
        component: JudgmentsOrdersComponent,
      },
      {
        path: 'search-judgments',
        component: SearchJudgmentsComponent,
      },
      {
        path: 'downloads',
        component: DownloadsComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
